import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { withStyles } from "@material-ui/core/styles";
import Lottie from "lottie-react";
// import loadingAnimation from "./loading-animation.json";
import loadingAnimation from "../../assets/lottie/loading-anim.json";
import styles from "./loadingViewStyles";

const LoadingView = ({ open, classes }) => {
  const [shouldShow, setShouldShow] = useState(false);
  const [startTime, setStartTime] = useState(null);

  useEffect(() => {
    console.log("open", open);
    if (open) {
      setShouldShow(true);
      setStartTime(Date.now());
    } else {
      const currentTime = Date.now();
      const elapsedTime = startTime ? currentTime - startTime : 0;
      console.log("elapsedTime", elapsedTime);

      if (elapsedTime >= 500 || !startTime) {
        setShouldShow(false);
        setStartTime(null);
      } else {
        const remainingTime = 500 - elapsedTime;
        console.log("remainingTime", remainingTime);
        setTimeout(() => {
          console.log("mintime elapsed set to true");
          setShouldShow(false);
          setStartTime(null);
        }, remainingTime);
      }
    }
  }, [open, startTime]);

  return (
    <Dialog
      open={shouldShow}
      className={classes.dialog}
      aria-labelledby="loading-dialog"
    >
      <DialogContent className={classes.dialogContent}>
        <div className={classes.lottieContainer}>
          <Lottie
            animationData={loadingAnimation}
            loop={true}
            autoplay={true}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(LoadingView);
